import React, { useState, useEffect } from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Logout from "./Logout";
import Sidebar from "./Sidebar";
import "../../assets/css/Mywishlist.css";
import { wish1, wish2, wish3 } from "../../constants";
import AuthHeader from "../../components/AuthHeader/AuthHeader";

const MyWishlist = () => {
	return (
		<>
			<AuthHeader />
			{/* My adresses starts here */}
			<section className="my-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-3">
							<Sidebar />
						</div>
						<div className="col-lg-9">
							<Logout />
							{/* wishlist starts here */}
							<div className="wishlist-wrapper">
								<div className="wishlist-heading-wrapper">
									<h3>My Wishlist</h3>
								</div>
								<div className="wishlis-table-wrapper">
									<div className="table-responsive">
										<table className="table">
											<thead>
												<tr>
													<th className="cross-col"></th>
													<th className="product-col">PRODUCT NAME </th>
													<th className="unit-col">UNIT PRICE</th>
													<th className="btn-col"></th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td className="cross">
														<button className="cross-btn">
															<i
																className="fa fa-times-circle-o"
																aria-hidden="true"
															></i>
														</button>
													</td>
													<td className="product-wrapper">
														<div className="img-wrapper">
															<img src={wish1} className="img-fluid" alt="" />
														</div>
														<div className="content-wrapper">
															<h5>JSC FASHION WOMEN'S BAG</h5>
														</div>
													</td>
													<td className="unit">
														<span className="unit-price">$158.07 </span>
													</td>
													<td className="cart-btn">
														<button className="btn">Add to cart</button>
													</td>
												</tr>
												<tr>
													<td className="cross">
														<button className="cross-btn">
															<i
																className="fa fa-times-circle-o"
																aria-hidden="true"
															></i>
														</button>
													</td>
													<td className="product-wrapper">
														<div className="img-wrapper">
															<img src={wish2} className="img-fluid" alt="" />
														</div>
														<div className="content-wrapper">
															<h5>JSC FASHION WOMEN'S BAG</h5>
														</div>
													</td>
													<td className="unit">
														<span className="unit-price">$158.07 </span>
													</td>
													<td className="cart-btn">
														<button className="btn">Add to cart</button>
													</td>
												</tr>
												<tr>
													<td className="cross">
														<button className="cross-btn">
															<i
																className="fa fa-times-circle-o"
																aria-hidden="true"
															></i>
														</button>
													</td>
													<td className="product-wrapper">
														<div className="img-wrapper">
															<img src={wish3} className="img-fluid" alt="" />
														</div>
														<div className="content-wrapper">
															<h5>JSC FASHION WOMEN'S BAG</h5>
														</div>
													</td>
													<td className="unit">
														<span className="unit-price">$158.07 </span>
													</td>
													<td className="cart-btn">
														<button className="btn">Add to cart</button>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
								<div className="paginations-wrapper">
									<ul>
										<li className="controls">
											<button className="back">
												<i className="fa fa-angle-left"></i>
											</button>
										</li>
										<li className="number">
											<button className="num">1</button>
										</li>
										<li className="number active">
											<button className="num">2</button>
										</li>
										<li className="number">
											<button className="num">3</button>
										</li>
										<li className="number">
											<button className="num">4</button>
										</li>
										<li className="controls">
											<button className="forward">
												<i className="fa fa-angle-right"></i>
											</button>
										</li>
									</ul>
								</div>
							</div>
							{/* wishlist ends here */}
						</div>
					</div>
				</div>
			</section>
			{/* My adresses ends here */}
			<Footer />
		</>
	);
};

export default MyWishlist;
